module.exports = __webpack_public_path__ + "img/news-slider1-en.b02c6932.jpg";